import { KendoBaseComponent, KendoBaseDatasourceComponent } from '@progress/kendo-base-components-vue-wrapper'
import DropDownListProps from './DropDownListProps'

import Animation from '../Common/Animation'
import Popup from '../Common/Popup'
import Virtual from '../Common/Virtual'

export default {
    props: DropDownListProps,
    render(createElement) {
        return createElement('input', [
            this.$slots['kendo-datasource']
        ])
    },
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        Animation,
        Popup,
        Virtual
    ],
    model:{
        event: 'changemodel'
    },
    mounted() {
        var that = this
        var widgetElement = that.$el

        kendo.jQuery(widgetElement).kendoDropDownList(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', widgetElement.value)
        })
    },
    methods: {
        kendoWidget() {
            var widgetElement = this.$el

            return kendo.jQuery(widgetElement).getKendoDropDownList()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoDropDownList/KendoDropDownListMixin.js